// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__1vlk7","thumbnail":"item_thumbnail__3aQXU","data":"item_data__eVSWl","category":"item_category__3Y07P","title":"item_title__3PeWo","date":"item_date__Cc5ix"};